import { Box, styled } from '@mui/material';
import { type SyntheticEvent, useState } from 'react';
import { type TabItem, Tabs as TabRow } from '@levelworks/webapp-ui-components';
import { Header, LwButton, Page, Toolbox } from 'redesign';
import { invariant } from 'shared/utils/utils';
import { useHqRelativePath } from 'hq/hooks/useHqRelativePath';
import { hqRoutes } from 'hq/Routes';
import { PlatformSettingsTab } from './tabs/platform-information-tab';
import { MinimumRateTab } from './tabs/minimum-rate-tab';
import { PlatformWorkImageTab } from './tabs/platform-work-image-tab';

const tabs: [TabItem, ...TabItem[]] = [
  { id: 'platform-information', label: 'Algemene informatie' },
  { id: 'minimal-wage', label: "Minimum tarief zzp'er" },
  { id: 'platform-work-image', label: 'Platform Work Image' },
];

export const PlatformSettingsPage = () => {
  const generatePath = useHqRelativePath();
  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  const handleTabChange = (_event: SyntheticEvent, tabId: string) => {
    const nextTab = tabs.find((tab) => tab.id === tabId);
    invariant(nextTab, 'Tab not found');
    setSelectedTab(nextTab);
  };

  return (
    <Page
      header={<Header titleText="Platform instellingen" />}
      toolbox={
        <ToolboxOffset>
          <Toolbox upperDivider={false}>
            <TabColumn>
              <TabRow
                aria-label="tabbladen"
                defaultValue={tabs[0].id}
                items={tabs}
                onChange={handleTabChange}
              />
              {selectedTab.id === 'platform-information' ? (
                <LwButton color="primary" to={generatePath(hqRoutes.PlatformSettingsUpdate)}>
                  Aanpassen
                </LwButton>
              ) : null}
            </TabColumn>
          </Toolbox>
        </ToolboxOffset>
      }
    >
      <Box width="100%">
        {selectedTab.id === 'platform-information' ? <PlatformSettingsTab /> : null}
        {selectedTab.id === 'minimal-wage' ? <MinimumRateTab /> : null}
        {selectedTab.id === 'platform-work-image' ? <PlatformWorkImageTab /> : null}
      </Box>
    </Page>
  );
};

const ToolboxOffset = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(-8),
}));

const TabColumn = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
  gap: theme.spacing(4),
}));
